import { persistor, store } from 'store/index'
import { PropsWithChildren, useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

const timeout = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
export const awaitRehydrate = async (): Promise<boolean> => {
  const state = store.getState()
  const rehydrated = state?._persist?.rehydrated
  console.debug('rehydrated', rehydrated)
  if (rehydrated) {
    return true
  } else {
    await timeout(10)
    return awaitRehydrate()
  }
}

export const useStoreRehydrate = () => {
  const [isReady, setIsReady] = useState(false)
  useEffect(() => {
    awaitRehydrate().then(() => {
      setIsReady(true)
    })
  }, [])

  return {
    isReady,
  }
}

export const StoreProvider = ({ children }: PropsWithChildren) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  )
}
